"use strict";

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _react = _interopRequireWildcard(require("react")),
    _loadPostcode = _interopRequireDefault(require("./loadPostcode")),
    _excluded = ["scriptUrl", "className", "style", "defaultQuery", "autoClose", "errorMessage", "width", "height", "onComplete", "onClose", "onResize", "onSearch"];

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _getRequireWildcardCache(a) {
  if ("function" != typeof WeakMap) return null;
  var b = new WeakMap(),
      c = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(a) {
    return a ? c : b;
  })(a);
}

function _interopRequireWildcard(a, b) {
  if (!b && a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    default: a
  };

  var c = _getRequireWildcardCache(b);

  if (c && c.has(a)) return c.get(a);
  var d = {},
      e = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var f in a) {
    if ("default" != f && Object.prototype.hasOwnProperty.call(a, f)) {
      var g = e ? Object.getOwnPropertyDescriptor(a, f) : null;
      g && (g.get || g.set) ? Object.defineProperty(d, f, g) : d[f] = a[f];
    }
  }

  return d.default = a, c && c.set(a, d), d;
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _objectWithoutProperties(a, b) {
  if (null == a) return {};

  var c,
      d,
      e = _objectWithoutPropertiesLoose(a, b);

  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(a);

    for (d = 0; d < f.length; d++) {
      c = f[d], 0 <= b.indexOf(c) || Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
    }
  }

  return e;
}

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

function _classCallCheck(a, b) {
  if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(a, b) {
  for (var c, d = 0; d < b.length; d++) {
    c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
}

function _createClass(a, b, c) {
  return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), a;
}

function _inherits(a, b) {
  if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(b && b.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), b && _setPrototypeOf(a, b);
}

function _setPrototypeOf(a, b) {
  return _setPrototypeOf = Object.setPrototypeOf || function (a, b) {
    return a.__proto__ = b, a;
  }, _setPrototypeOf(a, b);
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = _getPrototypeOf(a);

    if (b) {
      var e = _getPrototypeOf(this).constructor;

      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return _possibleConstructorReturn(this, c);
  };
}

function _possibleConstructorReturn(a, b) {
  return b && ("object" === _typeof(b) || "function" == typeof b) ? b : _assertThisInitialized(a);
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function _getPrototypeOf(a) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, _getPrototypeOf(a);
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var defaultErrorMessage = /*#__PURE__*/_react.default.createElement("p", null, "\uD604\uC7AC Daum \uC6B0\uD3B8\uBC88\uD638 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."),
    defaultStyle = {
  width: "100%",
  height: 400
},
    defaultProps = {
  scriptUrl: "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js",
  errorMessage: defaultErrorMessage,
  autoClose: !0
},
    DaumPostcode = /*#__PURE__*/function (a) {
  function b() {
    var a;

    _classCallCheck(this, b);

    for (var d = arguments.length, e = Array(d), f = 0; f < d; f++) {
      e[f] = arguments[f];
    }

    return a = c.call.apply(c, [this].concat(e)), _defineProperty(_assertThisInitialized(a), "wrap", /*#__PURE__*/(0, _react.createRef)()), _defineProperty(_assertThisInitialized(a), "state", {
      hasError: !1
    }), _defineProperty(_assertThisInitialized(a), "initiate", function (b) {
      if (a.wrap.current) {
        var c = a.props,
            d = c.scriptUrl,
            e = c.className,
            f = c.style,
            g = c.defaultQuery,
            h = c.autoClose,
            i = c.errorMessage,
            j = c.width,
            k = c.height,
            l = c.onComplete,
            m = c.onClose,
            n = c.onResize,
            o = c.onSearch,
            p = _objectWithoutProperties(c, _excluded),
            q = new b(_objectSpread(_objectSpread({}, p), {}, {
          oncomplete: function oncomplete(b) {
            l && l(b), h && a.wrap.current && a.wrap.current.remove();
          },
          onsearch: o,
          onresize: n,
          onclose: m,
          width: "100%",
          height: "100%"
        }));

        q.embed(a.wrap.current, {
          q: g,
          autoClose: h
        });
      }
    }), _defineProperty(_assertThisInitialized(a), "onError", function () {
      a.setState({
        hasError: !0
      });
    }), a;
  }

  _inherits(b, a);

  var c = _createSuper(b);

  return _createClass(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var a = this.initiate,
          b = this.onError,
          c = this.props.scriptUrl;
      c && (0, _loadPostcode.default)(c).then(a).catch(b);
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.className,
          c = a.style,
          d = a.errorMessage,
          e = this.state.hasError;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.wrap,
        className: b,
        style: _objectSpread(_objectSpread({}, defaultStyle), c)
      }, e && d);
    }
  }]), b;
}(_react.Component);

_defineProperty(DaumPostcode, "defaultProps", defaultProps);

var _default = DaumPostcode;
exports.default = _default;